// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/learning/EffectivenessBadge.jsx

import React from 'react';

const normalizeLabel = (value) => {
  if (value === null || value === undefined || value === '') return 'Unknown';
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const toPercent = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) return String(value);
  return `${numberValue % 1 === 0 ? numberValue.toFixed(0) : numberValue.toFixed(1)}%`;
};

const signalClass = (signal) => {
  const normalized = String(signal || '').toLowerCase();
  if (normalized.includes('strong') || normalized.includes('high') || normalized.includes('positive')) {
    return 'learning-badge-positive';
  }
  if (normalized.includes('risk') || normalized.includes('weak') || normalized.includes('low')) {
    return 'learning-badge-warning';
  }
  return 'learning-badge-neutral';
};

export default function EffectivenessBadge({ label, value, signal, suffix, compact = false }) {
  return (
    <div className={`learning-effectiveness-badge ${signalClass(signal)} ${compact ? 'learning-effectiveness-badge-compact' : ''}`}>
      <div className="learning-effectiveness-badge-label">{label}</div>
      <div className="learning-effectiveness-badge-value">
        {suffix === 'percent' ? toPercent(value) : value ?? '—'}
      </div>
      {signal ? <div className="learning-effectiveness-badge-signal">{normalizeLabel(signal)}</div> : null}
    </div>
  );
}
